import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { ValidMenuNameList } from '../Header/config/linkInfo';
import { errorControllerPropTypes } from '../ErrorController';

import {
  SMFooter,
  SMHeader,
  MobileBanner,
  SessionTimeoutModal,
  CookieBanner,
  StaticContext,
  ErrorController,
} from '../..';

const BasePageBody = ({
  color,
  headerVariant,
  footerVariant,
  errorCtrl,
  showBillingAddress,
  includeHeader,
  includeFooter,
  children,
  actionFlow,
  showCreateSurveyButton,
  sticky,
  isMRX,
  excludeMenuItems,
  showLoginButton,
  showSignupButton,
  Logo,
}) => {
  const {
    user,
    url,
    environment,
    locale,
    'client-config': clientConfig,
    GDPR,
  } = useContext(StaticContext);

  const {
    languageCode: language,
    countryCode: country,
    subdomain,
    domain,
    tld,
  } = environment;

  return (
    <>
      <If condition={includeHeader}>
        <SMHeader
          isAnonHeaderSticky={sticky}
          isUserAuthenticated={user.isAuthenticated}
          color={color}
          variant={headerVariant}
          lang={language}
          isEUDC={locale.isEUDC}
          actionFlow={actionFlow}
          user={user}
          showCreateSurveyButton={showCreateSurveyButton}
          isMRX={isMRX}
          excludeMenuItems={excludeMenuItems}
          showLoginButton={showLoginButton}
          showSignupButton={showSignupButton}
          Logo={Logo}
        />
      </If>
      <Choose>
        <When condition={errorCtrl}>
          <ErrorController {...errorCtrl}>{children}</ErrorController>
        </When>
        <Otherwise>{children}</Otherwise>
      </Choose>
      <If condition={includeFooter}>
        <SMFooter
          subdomain={subdomain}
          domain={domain}
          lang={language}
          country={country}
          isUserAuthenticated={user.isAuthenticated}
          showBillingAddress={showBillingAddress}
          variant={footerVariant}
          isEUDC={locale.isEUDC}
          tld={tld}
          url={url}
          onetrustBannerEnabled={GDPR.onetrustBannerEnabled}
        />
      </If>
      <If condition={user.isAuthenticated}>
        <>
          <SessionTimeoutModal user={user} />
          <MobileBanner downloadLink={clientConfig.mobileBannerDownloadLink} />
        </>
      </If>
      <If condition={!GDPR.onetrustBannerEnabled}>
        <CookieBanner GDPR={GDPR} />
      </If>
    </>
  );
};

const {
  children,
  ...childLessErrorControllerPropTypes
} = errorControllerPropTypes;

export const propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  includeHeader: PropTypes.bool,
  includeFooter: PropTypes.bool,
  errorCtrl: PropTypes.shape(childLessErrorControllerPropTypes),
  showBillingAddress: PropTypes.bool,
  headerVariant: PropTypes.oneOf(['default', 'limited', 'slim']),
  footerVariant: PropTypes.oneOf(['default', 'limited', 'slim']),
  actionFlow: PropTypes.string,
  showCreateSurveyButton: PropTypes.bool,
  sticky: PropTypes.bool,
  isMRX: PropTypes.bool,
  excludeMenuItems: PropTypes.arrayOf(PropTypes.oneOf(ValidMenuNameList)),
  showLoginButton: PropTypes.bool,
  showSignupButton: PropTypes.bool,
  Logo: PropTypes.node,
};

export const defaultProps = {
  color: 'primary',
  errorCtrl: null,
  showBillingAddress: false,
  headerVariant: 'default',
  footerVariant: 'default',
  includeHeader: true,
  includeFooter: true,
  actionFlow: 'header',
  showCreateSurveyButton: true,
  sticky: true,
  isMRX: false,
  excludeMenuItems: [],
  showLoginButton: true,
  showSignupButton: true,
  Logo: undefined,
};

BasePageBody.propTypes = propTypes;
BasePageBody.defaultProps = defaultProps;

export default BasePageBody;
